import { useClipboard } from '@vueuse/core'

import type { CanvasRetrieve, Canvas, SharedLink } from '@openapi'
import useAppEmit from '@lib/composables/appEmit.use'

export type SharingHandler = (canvasId: string) => Promise<SharedLink>

export default (
  sharingHandler: SharingHandler,
  options: { useShortUrl?: boolean; contextUpdater?: (id: CanvasRetrieve['id']) => Promise<void> } = {
    useShortUrl: false,
  },
) => {
  const { copy, copied } = useClipboard()
  const { appEmit } = useAppEmit()

  const emitShareEvent = (canvas: CanvasRetrieve | Canvas) => {
    appEmit('canvasShared', canvas)
  }

  const share = async (canvas: CanvasRetrieve | Canvas) => {
    let url = ''

    if ('shared_link' in canvas && canvas.shared_link) {
      url = options.useShortUrl ? canvas.shared_link.short_url || canvas.shared_link.url : canvas.shared_link.url
    } else {
      if (options.contextUpdater) await options.contextUpdater(canvas.id)

      const sharedLink = await sharingHandler(canvas.id)
      url = options.useShortUrl ? sharedLink.short_url || sharedLink.url : sharedLink.url
    }

    emitShareEvent(canvas)
    return url
  }

  const copySharingUrlToClipboard = async (canvas: CanvasRetrieve | Canvas) => {
    const url = await share(canvas)
    await copy(url)
    return { copied: copied.value, url }
  }

  return {
    copySharingUrlToClipboard,
    share,
    emitShareEvent,
  }
}
